<template>
    <modal id="hotel-floor-assignment-reassign-modal"
           size="default"
           v-model="showModal"
           :title="$t('reassign')"
           @submit="submitData" :loading="loading">

        <form ref="form" @submit.prevent="submitData">
            <app-form-group-selectable
                type="select"
                :label="$t('target_floor')"
                list-value-field="floor"
                list-value-id="floor"
                v-model="formData.target_floor"
                :required="true"
                :chooseLabel="$t('floor')"
                :error-message="$errorMessage(errors, 'target_floor')"
                :fetch-url="room_url"
            />
            <app-form-group-selectable
                type="multi-select"
                :label="$t('employee')"
                list-value-field="employee_name"
                v-model="formData.employee_ids"
                :required="true"
                :chooseLabel="$t('employee')"
                :error-message="$errorMessage(errors, 'employee_ids')"
                :fetch-url="employee_url"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "HotelFloorAssignmentReassignModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        assignment: {
            type    : Object,
            required: true
        }
    },
    data() {
        return {
            TENANT_BASE_URL,
            room_url       : null,
            employee_url   : null,
            formData       : {
                id           : this.assignment.id,
                employee_ids : [],
                target_floor : this.assignment.floor,
            },
        }
    },
    created() {
        this.room_url = `${TENANT_BASE_URL}selectable/hotel/room?group=floor&hotel_id=${this.assignment.hotel_id}`;
        
        if (this.assignment.work_date) {
            this.employee_url = `${TENANT_BASE_URL}selectable/hotel/floor-assignment/users?work_date=${this.assignment.work_date}`;
        }

        // Save employee_ids from assignment
        let employeeIds = [];
        if (this.assignment.employee_ids && Array.isArray(this.assignment.employee_ids)) {
            employeeIds = this.assignment.employee_ids.map(id => parseInt(id));
        }

        // Set employee_ids after the multi-select list has loaded
        setTimeout(() => {
            this.$set(this.formData, 'employee_ids', employeeIds);
        }, 1000);
    },
    methods: {
        submitData() {
            this.loading = true;

            this.submitFromFixin(
                'post',
                `${TENANT_BASE_URL}app/hotel/floor-assignment/reassign`,
                this.formData
            );
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#hotel-floor-assignment-reassign-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'hotel-floor-assignment-table');
        },
    },
}
</script>
